// extracted by mini-css-extract-plugin
module.exports = {"item":"keywords-module--item--1Mj1j","list":"keywords-module--list--2rkwB","link":"keywords-module--link--32HMQ"};